import { API_URL, getHeaders } from "../../utils/contextHelpers";
import { api, apiPost, deduplicate, request, buildQuery } from "./core";

export const getCotizacionesPropuestas = api("getCotizacionesPropuestas", (codigo) => `${API_URL}cotizacion/propuestas?codigo=${codigo}`);

const _getCotizacionesTabla = api("getCotizacionesTabla", ({
    tipo,
    rut = "",
    codigo = "",
    razonSocial = "",
    limit = 50,
    order = "",
}) => `${API_URL}cotizacion/tabla?${buildQuery({ tipo, rut, codigo, razonSocial, limit: String(limit), order })}`, { credentials: "include", redirect: "follow" });

export const getCotizacionesTabla = async ({tipo, rut = "", codigo = "", razonSocial = "", limit = 50, order = ""} = {}) => {
    const data = await _getCotizacionesTabla({tipo, rut, codigo, razonSocial, limit, order});
    if (!data || !data.clientes) throw new Error("Datos inválidos recibidos del servidor.");
    return data.clientes;
};

export const getCotizacion = api("getCotizacion", (codigo) => `${API_URL}cotizacion/cotizacion?codigo=${codigo}`);

export const getStock = api("getStock", (articulo) => `${API_URL}cotizacion/stock?articulo=${articulo}`);

export const postGrabar = apiPost("postGrabar", () => `${API_URL}cotizacion/grabar`, {
    body: (data) => {
        const formData = new URLSearchParams();
        Object.entries(data).forEach(([k, v]) => {
            if (v !== undefined && v !== null) formData.append(k, v);
        });
        return formData;
    }
});

export const getComboCierre = api("getComboCierre", (id_cotizacion, especial = false) => `${API_URL}cotizacion/comboCierre?id_cotizacion=${id_cotizacion}&especial=${especial}`);

export const getDetalle = (dialog, especial, id_cotizacion, interfaz, { forceRefresh = false } = {}) => {
    const key = `getDetalle-${dialog}-${especial}-${id_cotizacion}-${interfaz}`;
    const fetchDetalle = () => request(
        `${API_URL}cotizacion/detalle?dialog=${dialog}&especial=${especial}&id_cotizacion=${id_cotizacion}&interfaz=${interfaz}`,
        { method: "GET", headers: getHeaders() }
    );

    return forceRefresh ? fetchDetalle() : deduplicate(key, fetchDetalle);
};

export const getResumen = api("getResumen", (id, descuento, stock = false) => `${API_URL}cotizacion/resumen?id=${id}&descuento=${descuento}&stock=${stock}`);

export const getRelacionados = api("getRelacionados", (id_cotizacion) => `${API_URL}cotizacion/relacionados?id_cotizacion=${id_cotizacion}`);

export const getProductosRelacionados = api("getProductosRelacionados", (id_cotizacion, id_proyecto) => `${API_URL}relacionados?${buildQuery({ cotizacion: id_cotizacion, proyecto: id_proyecto })}`);

export const actualizarProyecto = api("actualizarProyecto", (id_cotizacion, id_proyecto) => `${API_URL}cotizacion/actualiza/proyecto?id_cotizacion=${id_cotizacion}&id_proyecto=${id_proyecto}`);

export const agregarProducto = api("agregarProducto", (id_cotizacion, codigo) => `${API_URL}cotizacion/agregar/producto?codigo=${codigo}&id_cotizacion=${id_cotizacion}`);

export const eliminarProducto = api("eliminarProducto", (id) => `${API_URL}cotizacion/eliminar?id=${id}`);

export const actualizarCantidad = api("actualizarCantidad", (cantidad, id) => `${API_URL}cotizacion/actualiza/cantidad?cantidad=${cantidad}&id=${id}`);

export const actualizarPrecios = api("actualizarPrecios", (id) => `${API_URL}cotizacion/actualizar/precios?id=${id}`);

export const asociarCotizacion = api("asociarCotizacion", (cliente_codigo = "", id = "") => {
    const c = String(cliente_codigo || "").trim();
    const i = String(id || "").trim();
    return `${API_URL}/cotizacion/asociar?cliente=${encodeURIComponent(c)}&cotizacion=${encodeURIComponent(i)}`;
});

export const descartarCotizacion = api("descartarCotizacion", (id) => `${API_URL}cotizacion/descartar?id=${id}`);

export const actualizarDescuento = api("actualizarDescuento", (descuento, id) => `${API_URL}cotizacion/actualiza/descuento?descuento=${descuento}&id=${id}`);

export const notificarCotizacion = api("notificarCotizacion", (id_cotizacion) => `${API_URL}cotizacion/notificar?id_cotizacion=${id_cotizacion}`);

export const existenciaCotizacion = api("existenciaCotizacion", (id_cotizacion) => `${API_URL}cotizacion/existencia?id_cotizacion=${id_cotizacion}`);

export const actualizarObservaciones = api("actualizarObservaciones", (id, observaciones) =>
    `${API_URL}cotizacion/actualiza/observaciones?id=${id}&observaciones=${encodeURIComponent(observaciones ?? "")}`
);

export const validarCotizacion = api("validarCotizacion", (id) => `${API_URL}cotizacion/validar?id=${id}`);

export const finalizarCotizacion = api("finalizarCotizacion", (id, descuento, observaciones) =>
    `${API_URL}cotizacion/finalizar?id=${id}&descuento=${descuento}&observaciones=${encodeURIComponent(observaciones ?? "")}`
);

export const pagarCredito = apiPost("pagarCredito", (id) => `${API_URL}cotizacion/pagar/credito?id=${id}`);

export const abrirCotizacionPDF = (id) => {
    const endpoint = `${API_URL}reporte/cotizaciones/pdf?historia=false&id=${id}`;
    window.open(endpoint, "_blank", "noopener,noreferrer");
};

export const inyectarCotizacion = api("inyectarCotizacion", (id) => `${API_URL}cotizacion/inyectar?forzar=false&id=${id}&test=false`);

export const actualizarPrecio = api("actualizarPrecio", (id, precio) => `${API_URL}cotizacion/actualiza/precio?dialog=false&id=${id}&precio=${precio}`);

export const recotizarCotizacion = api("recotizarCotizacion", (id) => `${API_URL}cotizacion/recotizar?id=${id}`);

export const revisarCotizacion = api("revisarCotizacion", (id) => `${API_URL}cotizacion/revisar?id=${id}`);

export const getCausaCotizacion = api("getCausaCotizacion", (id, id_causa) => `${API_URL}cotizacion/causa?id=${id}&id_causa=${id_causa}`);

export const getBotonCausaCotizacion = api("getBotonCausaCotizacion", (id) => `${API_URL}cotizacion/causa/boton?id=${id}`);

export const enviarCotizacionMayorista = api("enviarCotizacionMayorista", (idCotizacion, destinos, otros) => `${API_URL}cotizacion/enviar?${buildQuery({
    id: idCotizacion != null ? String(idCotizacion) : undefined,
    "destinos[]": destinos,
    otros: otros != null ? String(otros) : undefined,
})}`);

export const validarCupon = api("validarCupon", (codigo) => `${API_URL}cupon/validar?codigo=${encodeURIComponent(codigo)}`);

export const aplicarCupon = apiPost("aplicarCupon", (data) => `${API_URL}cupon/aplicar?idCotizacion=${data.id_cotizacion}&codigoCupon=${data.codigo}`);

export const removerCupon = apiPost("removerCupon", (data) => `${API_URL}cupon/remover?idCotizacion=${data.id_cotizacion}`);

export const cotizacionDetalleCheckout = api("cotizacionDetalleCheckout", (data) => `${API_URL}cotizacion/detalleCheckout?id=${data.id_cotizacion}`);